export enum ExamType {
    Simulated = 1,
    PreviousExam = 2
}
